import React, { type FunctionComponent } from 'react'
import { css } from '@emotion/react'
import { defaultLineHeight, fontSize, colors } from '@retailer-platform/shared-components'
import { MerchandisingFormField } from 'domains/merchandising/components/form-field/MerchandisingFormField'
import { MerchandisingFormInput } from 'domains/merchandising/components/form-input/MerchandisingFormInput'
import { MerchandisingFormRow } from 'domains/merchandising/components/form-row/MerchandisingFormRow'
import { MerchandisingFormSection } from 'domains/merchandising/components/form-section/MerchandisingFormSection'
import { HeroBannerFormDetailScheduler } from 'domains/merchandising/components/hero-banner-form/components/detail/HeroBannerFormScheduler'
import { useDashMessages } from 'intl/intl.hooks'
import { type ControllerProps } from 'utils/react-hook-form/reactHookForm.types'

const footnoteStyles = css({
  color: colors.GRAYSCALE.X70,
  fontSize: fontSize.X12,
  lineHeight: defaultLineHeight,
  maxWidth: '645px',
  width: '100%',
})

interface Props extends Omit<ControllerProps, 'name'> {}

export const HeroBannerFormDetail: FunctionComponent<Props> = ({ form }) => {
  const messages = useDashMessages({
    footnote: 'merchandising.hero-banners.section.detail.footnote',
  })

  const { errors, register, control } = form

  return (
    <MerchandisingFormSection titleId="merchandising.hero-banners.section.detail.title">
      <MerchandisingFormRow>
        <MerchandisingFormField>
          <MerchandisingFormInput
            ref={register({ required: true })}
            control={control}
            identifier="name"
            labelId="merchandising.hero-banners.section.detail.field.placementName.label"
            errors={errors}
          />
        </MerchandisingFormField>
      </MerchandisingFormRow>
      <MerchandisingFormRow>
        <MerchandisingFormField fullWidth>
          <HeroBannerFormDetailScheduler form={form} />
        </MerchandisingFormField>
      </MerchandisingFormRow>
      <div css={footnoteStyles}>{messages.footnote}</div>
    </MerchandisingFormSection>
  )
}
